module.exports = __webpack_public_path__ + "assets/gold.10f12fb9.svg";